import React, { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

const SSPan = styled.span`
    display: flex;
    align-items: center;
`

interface ILockIconProps extends ComponentPropsWithoutRef<'span'> {
    fill?: string
    size?: number
}

export function LockIcon({ fill, size = 14, title, id = 'lock-icon', ...rest }: ILockIconProps): React.ReactElement {
    return (
        <SSPan title={title} id={id} {...rest}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill ?? 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-lock"
            >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
        </SSPan>
    )
}
